<ng-container *ngIf="treeNode">
	<div #node class="node">
		<div [ngClass]="{'isSelected': selected }" class="node-data">
			<div (click)="selectObject()" *ngFor="let i of (treeNode().depth | fori)" class="depth-spacer"></div>
			<div class="data">
				<div (click)="switchExpandState()" [ngClass]="{'has-children': treeNode().hasChild, 'expanded': treeNode().expanded  }" class="chevron">

				</div>
				<div (click)="selectObject()" [style.background-image]="'url(\'' + treeNode().imageURL + '\')'" class="icon">

				</div>
				<div (click)="selectObject()" class="name">
					{{ treeNode().name }}
				</div>
			</div>
			<div [ngStyle]="{'background-color': showStatusColorInTree()? '#'+ treeNode().color : 'none' }" class="status-color"></div>
		</div>
		<ng-container #childrenContainer></ng-container>
	</div>
</ng-container>
